import { Errors } from '@enauka/shared/infrastructure/error-handling';
import { DialogService } from '@enauka/shared/ui/dialogs';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '@enauka/shared/infrastructure/auth/data-access';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'enauka-renew-password-dialog',
  templateUrl: './renew-password-dialog.component.html',
  styleUrls: ['./renew-password-dialog.component.css']
})
export class RenewPasswordDialogComponent implements OnInit {
  email: string;
  error: string;

  static open(dialogService: DialogService): NgbModalRef {
    return dialogService.open(RenewPasswordDialogComponent, {}, { backdrop: 'static' });
  }

  constructor(public activeModal: NgbActiveModal,
    private authService: AuthService,
    private dialogService: DialogService) { }

  ngOnInit(): void {
  }

  zamknij() {
    this.activeModal.close('cancel');
  }

  renewPassword() {
    this.authService.inicjujResetHasla(this.email)
      .subscribe(() => {
        this.zamknij();
        this.dialogService.messageInfo('Na podany adres email został wysłany odnośnik do zmiany hasła.');
      }, (err) => {
        this.error = Errors.getMessage(err);
      });
  }

}
